import { UtenteVO } from "./utenteVO";
import { ValoreCampoVO } from "./valori-campoVO";

export class AnagraficaCampoSpecificoVO {
  id: string;
  nomeCampo: string;
  tipoCampo: string;
  listaValori: string[];
  listaOutput: ValoreCampoVO[];
  dataCreazione: string;
  dataModifica: string;
  operatore: UtenteVO;
}
